export const reportesRoutes = [
  {
    path: '/reports',
    name: 'Reportes',
    component: () =>
      import(
        /* webpackChunkName: "reportes" */ '@/modules/Reportes/views/Reportes/ReportesIndex.vue'
      ),
    icon: 'mdiChartBar',
    typeIcon: 'mdi',
    menu: true,
    desplegable: false,
    meta: {
      title: 'Reportes',
      requiresSession: true,
      permiso: [],
      perfiles: [],
      showBackButton: false
    },
    children: []
  },
  {
    path: '/reports/report/:id',
    name: 'ReportesTabla',
    component: () =>
      import(
        /* webpackChunkName: "reportes" */ '@/modules/Reportes/views/Reportes/ReportesTable.vue'
      ),
    icon: 'ChartBarIcon',
    menu: false,
    desplegable: false,
    meta: {
      title: 'Consultar reporte',
      requiresSession: true,
      permiso: []
    },
    children: []
  },
  {
    path: '/reports/create',
    name: 'ReportesCreate',
    component: () =>
      import(
        /* webpackChunkName: "reportes" */ '@/modules/Reportes/views/Reportes/ReportesForm.vue'
      ),
    icon: 'ChartBarIcon',
    menu: false,
    desplegable: false,
    meta: {
      title: 'Registrar reporte',
      requiresSession: true,
      permiso: []
    },
    children: []
  },
  {
    path: '/reports/create/:id',
    name: 'ReportesUpdate',
    component: () =>
      import(
        /* webpackChunkName: "reportes" */ '@/modules/Reportes/views/Reportes/ReportesForm.vue'
      ),
    icon: 'ChartBarIcon',
    menu: false,
    desplegable: false,
    meta: {
      title: 'Actualizar reporte',
      requiresSession: true,
      permiso: []
    },
    children: []
  }
]
